import { createFileRoute } from "@tanstack/react-router";

import { parseBankCallsSearch } from "@/features/money";
import { BankCallsPage } from "@/features/money/pages";
import { ProblemError } from "@/shared/api/problem";
import { strictSearch } from "@/shared/lib/search";

/** The calls to the bank: hg-billing gives them to a superadmin alone. */
export const Route = createFileRoute("/_app/money/bank-calls")({
  beforeLoad: ({ context }) => {
    if (context.role !== "superadmin") {
      throw new ProblemError({ status: 403, code: "forbidden", title: "Forbidden" });
    }
  },
  validateSearch: strictSearch(parseBankCallsSearch),
  component: BankCalls,
});

function BankCalls() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <BankCallsPage
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
